import React, { useMemo, useState } from 'react';

import { debounce } from 'lodash';

import { ChipLoader } from 'components/v2';

import FiltersSelectHeader from '../FiltersSelectHeader';

import { DEFAULT_PARAMS, FORM_BUILDER_PARAMS, TRUE_TIME_PARAMS } from './constants';
import FilterProvidersList from './FilterProvidersList';

export enum FilterProvidersTypeEnum {
  formBuilderConfig = 'form_builder',
  trueTimeConfig = 'trueTimeProvider',
}

interface FilterProvidersProps {
  type?: FilterProvidersTypeEnum;
}

const CUSTOM_PARAMS = {
  [FilterProvidersTypeEnum.formBuilderConfig]: FORM_BUILDER_PARAMS,
  [FilterProvidersTypeEnum.trueTimeConfig]: TRUE_TIME_PARAMS,
};

const getParams = (type: FilterProvidersTypeEnum | undefined, query: string) => {
  switch (type) {
    case FilterProvidersTypeEnum.formBuilderConfig:
      return { ...CUSTOM_PARAMS[type], name: `${query}*` };
    case FilterProvidersTypeEnum.trueTimeConfig:
      return { ...CUSTOM_PARAMS[type], searchByPartialName: query };
    default:
      return { ...DEFAULT_PARAMS, searchByPartialName: query };
  }
};

const FilterProviders: React.FC<FilterProvidersProps> = ({ type }) => {
  const [providerNameSearch, setProviderNameSearch] = useState<string>('');
  const params = useMemo(() => getParams(type, providerNameSearch), [type, providerNameSearch]);

  const handleOnSearchChange = debounce((search: string) => setProviderNameSearch(search), 500);

  return (
    <React.Fragment>
      <FiltersSelectHeader type="providers" customType={type} onSearchChange={handleOnSearchChange} />
      <FilterProvidersList type="providers" params={params} />
    </React.Fragment>
  );
};

export default (props: any) => (
  <React.Suspense fallback={<ChipLoader />}>
    <FilterProviders {...props} />
  </React.Suspense>
);
